import { render, staticRenderFns } from "./ArticleHeadline.vue?vue&type=template&id=97b8b0fe&scoped=true"
import script from "./ArticleHeadline.vue?vue&type=script&lang=ts"
export * from "./ArticleHeadline.vue?vue&type=script&lang=ts"
import style0 from "./ArticleHeadline.vue?vue&type=style&index=0&id=97b8b0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b8b0fe",
  null
  
)

export default component.exports